import _objectSpread from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import CommonProblemSubModal from "./components/CommonProblemSubModal.vue";
export default {
  name: "commonProblemSub",
  components: {
    Modal: CommonProblemSubModal
  },
  data: function data() {
    return {
      searchForm: {
        pageSize: 20,
        pageNum: 1
      },
      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0,
      dialogVisible: false,
      // 弹窗状态
      title: "",
      categoryId: ""
    };
  },
  created: function created() {
    this.title = this.$route.query.name;
    this.categoryId = this.$route.query.id;
  },
  mounted: function mounted() {
    this.getData();
  },
  methods: {
    showModal: function showModal(row) {
      this.$refs.modal.show(row, this.categoryId);
    },
    back: function back() {
      this.$router.back();
    },
    // 更新排序
    updateSort: function updateSort(row) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return _this.$api.updateFaqAdvisory(row);
            case 1:
              _this.$message.success("操作成功");
              _this.getData();
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    pageChange: function pageChange(pn) {
      this.searchForm.pageNum = pn;
      this.getData();
    },
    getData: function getData() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _res$data, _res$data2;
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _this2.tableLoading = true;
              _context2.n = 1;
              return _this2.$api.getFaqAdvisoryList(_objectSpread({
                categoryId: _this2.categoryId
              }, _this2.searchForm));
            case 1:
              res = _context2.v;
              _this2.tableData = ((_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.content) || [];
              _this2.total = ((_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.totalSize) || 0;
              _this2.tableLoading = false;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    delData: function delData(row) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return _this3.$api.delFaqAdvisory({
                id: row.id
              });
            case 1:
              res = _context3.v;
              res.data && _this3.$message.success("已删除");
              _this3.getData();
              _this3.$operationLog.push({
                operationType: "text",
                code: "delete",
                detailBatchNo: row.questionZh
              });
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    updateDialog: function updateDialog(row) {
      this.form = row;
      this.dialogVisible = true;
    }
  }
};